module.exports = __webpack_public_path__ + "static/morguard-logo-775e6f93cb9cf3e9c7e8e44d0e632cab.jpg";